import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerhireinhinjewadipune() {



  const cardData = {
"keyword": "Tempo Traveller hire in Hinjewadi Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller hire in Hinjewadi, Pune for IT corporate travel, family trips, wedding groups, airport transfers, school tours, and outstation journeys. Our fleet includes 9, 12, 14, 17, 20, and 26-seater tempo travellers with AC, pushback seats, spacious interiors, and experienced drivers familiar with Hinjewadi IT Park routes. We ensure safe, comfortable, and punctual group travel across Pune and Maharashtra with flexible rental plans and doorstep pickup from all phases of Hinjewadi.",

"topPlaces": [
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
  {
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},

{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
}
],



services: [
  {
    name: "14 Seater Tempo Traveller Hire Hinjewadi",
    description: "14 seater Tempo Traveller hire Hinjewadi service provides comfortable transportation for corporate travel, airport transfers, sightseeing tours, family outings, and outstation journeys. Spacious seating and luggage space ensure smooth travel experiences suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient 14 seater traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Hinjewadi",
    description: "17 seater Tempo Traveller Hinjewadi service offers spacious transportation for employee outings, pilgrimage journeys, educational tours, family vacations, and tourist travel. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for larger passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "20 Seater Tempo Traveller Hinjewadi",
    description: "20 seater Tempo Traveller Hinjewadi service provides reliable transportation for corporate events, airport transfers, wedding functions, office outings, and group travel requirements. Spacious interiors and luggage capacity ensure comfortable journeys suitable for medium and large passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "Tempo Traveller for Corporate Outing Hinjewadi",
    description: "Tempo Traveller for corporate outing Hinjewadi service offers professional transportation for employee recreation trips, office outings, conferences, team-building events, and company travel requirements. Spacious seating and comfortable interiors ensure smooth travel experiences suitable for IT professionals and office teams. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient corporate outing traveller reservations."
  },
  {
    name: "Tempo Traveller for IT Employees Hinjewadi",
    description: "Tempo Traveller for IT employees Hinjewadi service provides dependable transportation for employee movement, office shuttle services, business meetings, airport transfers, and company outings. Spacious seating and smooth travel performance ensure comfortable journeys suitable for IT professionals and executive teams. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient IT employee traveller reservations."
  },
  {
    name: "Tempo Traveller for Airport Pickup Hinjewadi",
    description: "Tempo Traveller for airport pickup Hinjewadi service offers reliable transportation for tourists, business travelers, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional drivers ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and Pune Airport across Hinjewadi Pune. Flexible booking options allow convenient airport traveller reservations."
  },
  {
    name: "Tempo Traveller for Wedding Hinjewadi",
    description: "Tempo Traveller for wedding Hinjewadi service provides stylish transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "Tempo Traveller for Outstation Hinjewadi",
    description: "Tempo Traveller for outstation Hinjewadi service offers dependable long-distance transportation for Goa tours, pilgrimage journeys, family vacations, sightseeing trips, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient outstation traveller reservations."
  },
  {
    name: "Hinjewadi to Shirdi Tempo Traveller",
    description: "Hinjewadi to Shirdi Tempo Traveller service provides comfortable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Hinjewadi Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Hinjewadi to Mumbai Tempo Traveller",
    description: "Hinjewadi to Mumbai Tempo Traveller service offers reliable long-distance transportation for corporate travel, sightseeing journeys, airport transfers, family trips, and tourist travel. Spacious seating and smooth expressway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient Mumbai traveller reservations."
  },
  {
    name: "Hinjewadi to Lonavala Tempo Traveller",
    description: "Hinjewadi to Lonavala Tempo Traveller service provides comfortable hill station transportation for sightseeing tours, family vacations, office outings, and weekend trips from Hinjewadi Pune. Spacious interiors and smooth expressway travel ensure pleasant journeys suitable for tourist and corporate groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient Lonavala traveller reservations."
  },
  {
    name: "Hinjewadi to Mahabaleshwar Tempo Traveller",
    description: "Hinjewadi to Mahabaleshwar Tempo Traveller service offers dependable transportation for hill station vacations, sightseeing tours, family outings, and tourist travel from Hinjewadi Pune. Spacious seating and smooth ghat road travel ensure comfortable journeys suitable for family and corporate groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Hinjewadi to Goa Tempo Traveller",
    description: "Hinjewadi to Goa Tempo Traveller service provides premium long-distance transportation for beach vacations, sightseeing tours, bachelor trips, and family holidays from Hinjewadi Pune. Spacious seating and luggage capacity ensure smooth highway journeys suitable for tourist and group travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Goa route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller Hinjewadi",
    description: "Luxury Tempo Traveller Hinjewadi service offers premium transportation for weddings, corporate events, airport transfers, sightseeing tours, and family vacations. Spacious luxury interiors and elegant seating ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, railway stations, and airports across Hinjewadi Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "AC Tempo Traveller Hinjewadi",
    description: "AC Tempo Traveller Hinjewadi service provides premium air-conditioned transportation for business travel, educational tours, airport transfers, office outings, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, railway stations, and airports across Hinjewadi Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Non AC Tempo Traveller Hinjewadi",
    description: "Non AC Tempo Traveller Hinjewadi service offers affordable transportation for educational tours, local sightseeing, office travel, school trips, and group journeys. Spacious seating and smooth travel ensure comfortable experiences suitable for budget-friendly travel requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient non AC traveller reservations."
  },
  {
    name: "Affordable Tempo Traveller Hinjewadi",
    description: "Affordable Tempo Traveller Hinjewadi service provides economical transportation for family outings, school trips, office travel, sightseeing tours, weddings, and local or outstation journeys. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient affordable traveller reservations."
  }
],

tableData: [
  ["14 Seater Tempo Traveller Hire Hinjewadi", "17 Seater Tempo Traveller Hinjewadi"],
  ["20 Seater Tempo Traveller Hinjewadi", "Tempo Traveller for Corporate Outing Hinjewadi"],
  ["Tempo Traveller for IT Employees Hinjewadi", "Tempo Traveller for Airport Pickup Hinjewadi"],
  ["Tempo Traveller for Wedding Hinjewadi", "Tempo Traveller for Outstation Hinjewadi"],
  ["Hinjewadi to Shirdi Tempo Traveller", "Hinjewadi to Mumbai Tempo Traveller"],
  ["Hinjewadi to Lonavala Tempo Traveller", "Hinjewadi to Mahabaleshwar Tempo Traveller"],
  ["Hinjewadi to Goa Tempo Traveller", "Luxury Tempo Traveller Hinjewadi"],
  ["AC Tempo Traveller Hinjewadi", "Non AC Tempo Traveller Hinjewadi"],
  ["Affordable Tempo Traveller Hinjewadi", "14 Seater Tempo Traveller Hire Hinjewadi"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller Hire in Hinjewadi Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller hire service in Hinjewadi Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate tours, family trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller hire in Hinjewadi Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller hire service in Hinjewadi Pune operates 24 hours for employee transportation, airport transfers, office outings, weddings, pilgrimage tours, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, corporate outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for office teams, family groups, wedding travel, tourists, and employee transportation."
      },
      {
        WhyChooseheading: "Pickup Available Across Hinjewadi & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Hinjewadi Phase 1, Phase 2, Phase 3, Wakad, Baner, Balewadi, Marunji, Tathawade, and nearby IT parks for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller hire in Hinjewadi Pune?", answer: "Tempo Traveller hire service in Hinjewadi Pune provides comfortable group transportation for corporate travel, employee transport, family tours, weddings, and outstation journeys." },
    { question: "Is Tempo Traveller booking available 24 hours in Hinjewadi?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller hire service in Hinjewadi Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel from Hinjewadi?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Hinjewadi Pune." },
    { question: "Do you provide Tempo Travellers for corporate events in Hinjewadi?", answer: "Yes, Aaradhya Travels provides Tempo Traveller hire service for corporate meetings, office outings, conferences, and employee transportation in Hinjewadi." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Hinjewadi Pune?", answer: "Yes, customers can easily book Tempo Traveller hire service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller hire charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller hire service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Deshmukh",
    feedback:
      "Aaradhya Travels arranged a Tempo Traveller hire in Hinjewadi for our office outing, and the travel experience was very comfortable. The vehicle was clean, spacious, and made group movement across the city very easy.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Patil",
    feedback:
      "Tempo Traveller hire in Hinjewadi through Aaradhya Travels was very well managed for our family function. The journey was smooth, and everyone could travel together without any stress or delays.",
    rating: 5
  }
];



  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire in Hinjewadi Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-hire-in-hinjewadi.jpg",
  "description": "Book Tempo Traveller hire in Hinjewadi Pune with Aaradhya Travels for IT company travel, corporate outings, weddings, airport transfers, family trips, and outstation journeys. Available in 14, 17, and 20 seater options for Shirdi, Mumbai, and Maharashtra routes.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3715"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-hire-in-hinjewadi"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller Hire in Hinjewadi Pune | IT & Corporate Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller in Hinjewadi Pune with Aaradhya Travels. Affordable 14, 17, and 20 seater tempo travellers available for IT employees, corporate outings, weddings, airport pickup, Shirdi trips, Mumbai travel, and outstation tours."
  />

  <meta
    name="keywords"
    content="14 seater tempo traveller hire Hinjewadi, 17 seater tempo traveller Hinjewadi, 20 seater tempo traveller Hinjewadi, Tempo traveller for corporate outing Hinjewadi, Tempo traveller for IT employees Hinjewadi, Tempo traveller for airport pickup Hinjewadi, Tempo traveller for wedding Hinjewadi, Tempo traveller for outstation Hinjewadi, Hinjewadi to Shirdi tempo traveller, Hinjewadi to Mumbai tempo traveller"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerhireinhinjewadipune;